export default __webpack_public_path__ + "static/media/payment-recurrence-migration.e49fa96e.png";